import classNames from 'classnames';
import { DetailedHTMLProps, FC, LiHTMLAttributes } from 'react';

export interface ListItemProps extends DetailedHTMLProps<LiHTMLAttributes<HTMLLIElement>, HTMLLIElement> {
  className?: string;
  content?: string;
  link?: boolean;
  to?: string;
}

const ListItem: FC<ListItemProps> = ({ link, to, content, className, children, ...props }) => {
  const listItemClassName = classNames('list-item', className);

  let renderItem = children;

  if (content) {
    renderItem = <p>{content}</p>;
  }

  return (
    <li className={listItemClassName} {...props}>
      {renderItem}
    </li>
  );
};

export default ListItem;
